'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { Eye, EyeOff, ArrowUpRight, Plus, Send } from 'lucide-react';
import { useAppStore } from '@/hooks/useAppStore';

export default function WalletPeekCard() {
  const [balanceVisible, setBalanceVisible] = useState(true);
  const { credits, walletBalance } = useAppStore();

  return (
    <div className="wallet-card p-5">
      <div className="flex items-start justify-between mb-4">
        <div>
          <p className="text-xs font-600 mb-1" style={{ color: 'rgba(0,200,83,0.7)' }}>MKUBWA WALLET</p>
          <div className="flex items-end gap-2">
            {balanceVisible ? (
              <span className="text-3xl font-800 font-tabular text-gradient-green">KES {walletBalance?.toLocaleString()}.00</span>
            ) : (
              <span className="text-3xl font-800">••••••</span>
            )}
            <button onClick={() => setBalanceVisible(!balanceVisible)} className="mb-1 p-1 rounded-lg transition-all hover:bg-white/10">
              {balanceVisible ? <EyeOff size={16} style={{ color: 'rgba(0,200,83,0.6)' }} /> : <Eye size={16} style={{ color: 'rgba(0,200,83,0.6)' }} />}
            </button>
          </div>
          <p className="text-xs font-500 mt-1" style={{ color: 'var(--muted-foreground)' }}>
            Available balance · Updated just now
          </p>
        </div>

        <div className="flex flex-col items-end gap-1">
          <div className="px-2.5 py-1 rounded-full text-[10px] font-600"
            style={{ background: 'rgba(0,200,83,0.12)', color: 'var(--primary)', border: '1px solid rgba(0,200,83,0.2)' }}>
            VERIFIED
          </div>
          <p className="text-[10px] font-500" style={{ color: 'var(--muted-foreground)' }}>{credits} credits</p>
        </div>
      </div>
      <div className="flex gap-3">
        <Link href="/wallet-screen"
          className="flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl text-sm font-600 transition-all duration-150 active:scale-95"
          style={{ background: 'var(--primary)', color: 'var(--primary-foreground)' }}>
          <Plus size={16} /> Top Up
        </Link>
        <Link href="/wallet-screen"
          className="flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl text-sm font-600 transition-all duration-150 active:scale-95"
          style={{ background: 'rgba(0,200,83,0.1)', color: 'var(--primary)', border: '1px solid rgba(0,200,83,0.2)' }}>
          <Send size={16} /> Send
        </Link>
        <Link href="/wallet-screen"
          className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-sm font-600 transition-all duration-150 active:scale-95"
          style={{ background: 'var(--secondary)', color: 'var(--muted-foreground)', border: '1px solid var(--border)' }}>
          <ArrowUpRight size={16} />
        </Link>
      </div>
    </div>
  );
}